<div class="header-main row-1140">
  <a class="header-main__logo" routerLink="/">
    <img src="assets/images/logo.svg" alt="PinPag" title="PinPag" />
  </a>

  <nav class="header-main__nav" aria-label="Menu principal">
    <ul class="header-main__desktop">
      @for (item of items; track item.label) {
        <li [class.with-submenu]="item.children">
          <a [routerLink]="item.route" [title]="item.title ?? item.label">
            {{ item.label }}
            @if (item.children) {
              <span class="material-symbols-outlined" aria-hidden="true">keyboard_arrow_down</span>
            }
          </a>
          @if (item.children) {
            <ul class="submenu">
              @for (child of item.children; track child.label) {
                <li>
                  @if (child.route) {
                    <a [routerLink]="child.route">{{ child.label }}</a>
                  } @else {
                    <a [href]="child.href" target="_blank" rel="noopener">{{ child.label }}</a>
                  }
                </li>
              }
            </ul>
          }
        </li>
      }
      <li>
        <a class="client-area" [href]="clientAreaUrl" title="Área do cliente">Área do cliente</a>
      </li>
    </ul>

    <button
      type="button"
      class="header-main__toggle"
      aria-label="Abrir menu"
      aria-controls="header-menu"
      [attr.aria-expanded]="menuOpen()"
      (click)="menuToggle.emit()"
    >
      <span class="material-symbols-outlined" aria-hidden="true">menu</span>
    </button>
  </nav>
</div>
